import React from 'react';
import { Box, Modal, Typography, Button } from '@mui/material';

const InvoiceYearModal = ({ open, anno, selectedCount = 0, onChangeAnno, onClose, onGenera }) => (
    <Modal open={open} onClose={onClose} aria-labelledby="year-modal-title">
        <Box
            sx={{
                position: 'absolute', top: '50%', left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 300, bgcolor: 'background.paper', boxShadow: 24, borderRadius: 3,
                p: 3, outline: 'none',
            }}
        >
            <Typography variant="h6" id="year-modal-title" gutterBottom fontWeight={600}>
                Nuova Fattura
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
                {selectedCount > 0
                    ? `Hai selezionato ${selectedCount} attività. Seleziona l'anno fiscale per la fattura unica.`
                    : "L'attività è stata chiusa in un anno precedente. Seleziona l'anno fiscale per la fattura."}
            </Typography>
            <input
                type="number"
                value={anno}
                onChange={(e) => onChangeAnno(e.target.value)}
                style={{
                    width: '100%', padding: '8px', fontSize: '16px',
                    borderRadius: '4px', border: '1px solid #ccc', marginBottom: '16px',
                }}
            />
            <Box display="flex" justifyContent="flex-end" gap={1}>
                <Button onClick={onClose}>Annulla</Button>
                <Button variant="contained" onClick={onGenera}>Genera</Button>
            </Box>
        </Box>
    </Modal>
);

export default InvoiceYearModal;